<mat-icon
  matTooltipPosition="after"
  class="h-4 w-4"
  matTooltipClass="enx-tooltip"
  [svgIcon]="icon()"
  [matTooltip]="hasTooltip() ? tooltip() : ''"
  [ngClass]="{ 'cursor-pointer': !hasTooltip() }"
  (click)="open($event)"
></mat-icon>
